import { components, useApi } from "@appretio/api";
import { useMutation } from "@tanstack/react-query";
import { useKeyedSave } from "./useKeyedSave";

type ForecastSummarySaveInput =
  components["schemas"]["ForecastSummarySaveInput"];
type ForecastSummarySaveOutput =
  components["schemas"]["ForecastSummarySaveOutput"];

export function useSaveForecastSummaryData() {
  const apiClient = useApi();
  const save = useKeyedSave(
    (body: ForecastSummarySaveInput & { save_id: string }) =>
      apiClient.POST("/v2/forecast/summary/save", { body })
  );

  return useMutation({
    mutationFn: async (
      input: Omit<ForecastSummarySaveInput, "save_id">
    ): Promise<ForecastSummarySaveOutput> => {
      const response = await save(input);
      const result = response.data?.result;
      if (!result) {
        throw new Error("Missing result in save response");
      }
      return result;
    },
    // The save id decides whether a repeat is safe; useKeyedSave owns it.
    retry: false,
    meta: {
      errorMessage: "Failed to save forecast summary data"
    }
  });
}
